import { conditionMessages } from './condition-messages.js'
import { enumOptionsZh } from './enum-options.js'
import { sectionCatalogZh } from './section-catalog.js'

export const zh = {
  visualGameStudio: {
    brand: 'Visual Game Studio',
    localizationUnsupported: '该历史版本缺少完整的编译数据，不支持生成多语言内容。请选择其他版本。',
    seal: '戏',
    viewport: {
      title: '请在更大屏幕使用',
      body: 'Visual Game Studio 是桌面创作工具，请使用宽度 1024px 以上的屏幕编辑剧本。',
    },
    nav: {
      projects: '剧本',
      editor: '编辑',
      assets: '素材',
      versions: '版本',
      turnVideos: '回合视频',
      runChain: '链路视图',
      localization: '多语言',
      help: '帮助',
      settings: '设置',
    },
    auth: {
      title: '登录创作端',
      subtitle: '使用平台账号管理剧本、素材、版本和发布。',
      email: '邮箱',
      password: '密码',
      login: '登录',
      logout: '退出登录',
      loggingIn: '登录中',
      failed: '登录失败',
    },
    topbar: {
      preview: '预览',
      publish: '发布',
      noProject: '未选择剧集',
      account: '账号',
    },
    projects: {
      title: '我的剧本',
      subtitle: '先管理剧本，再进入剧本维护每一关。',
      tags: '标签', bulkTags: '批量标签', bulkTagsPlaceholder: '奇幻, 恋爱, 悬疑', applyToFiltered: '应用到筛选出的 {count} 个剧本', bulkTagsApplied: '已为 {count} 个剧本更新标签',
      newProject: '新建剧集',
      search: '搜索剧集',
      filterAll: '全部',
      filterDraft: '草稿',
      filterPublished: '已发布',
      sortUpdated: '最近更新',
      sortEpisode: '关卡顺序',
      levelNumber: '第 {number} 关',
      emptyTitle: '还没有剧集',
      emptyBody: '创建第一个志怪剧本后进入结构化编辑。',
      edit: '编辑',
      duplicate: '复制',
      rename: '重命名',
      visibility: '可见性',
      delete: '归档/删除',
      createTitle: '新建剧集',
      editTitle: '编辑剧集信息',
      projectTitle: '标题',
      seriesId: '所属剧本标识',
      seriesIdPlaceholder: '例如 painted_skin',
      seriesTitle: '所属剧本名称',
      scriptTitle: '剧本名称',
      seriesTitlePlaceholder: '例如 画皮',
      episodeNo: '第几关',
      episodeNoPlaceholder: '1',
      seriesHint: '独立关卡请将三项全部留空；加入剧本时三项必须同时填写，同一剧本内关卡序号不可重复。',
      newSeries: '新建剧本',
      createSeries: '创建剧本',
      createSeriesTitle: '新建剧本',
      createSeriesHint: '创建剧本时会同时创建第一关。之后可进入剧本继续添加关卡。',
      firstLevelTitle: '第一关名称',
      firstLevelTitlePlaceholder: '例如 初入兰若寺',
      seriesCreated: '剧本和第一关已创建',
      seriesSection: '剧本',
      standaloneSection: '独立关卡',
      manageLevels: '管理关卡',
      levelCount: '{count} 个关卡',
      newLevel: '新建关卡',
      newStandalone: '新建独立关卡',
      backToSeries: '返回剧本列表',
      seriesLevelsSubtitle: '按顺序管理这个剧本的 {count} 个关卡。',
      belongsToSeries: '所属剧本',
      searchLevels: '搜索当前剧本的关卡',
      searchStandalone: '搜索独立关卡',
      noMatchingLevels: '没有符合条件的关卡',
      locale: '语言',
      associateLevel: '关联已有关卡',
      associateLevelTitle: '关联独立关卡',
      associateLevelHint: '将原独立关卡直接加入「{series}」，不会创建副本或改动关卡内容。',
      standaloneLevel: '独立关卡',
      selectStandaloneLevel: '请选择独立关卡',
      levelAssociated: '关卡已关联到剧本',
      associateLevelFailed: '关联关卡失败',
      private: '私有',
      public: '公开',
      unlisted: '不公开列出',
      save: '保存',
      cancel: '取消',
      creating: '创建中',
      saving: '保存中',
      loading: '加载剧集中',
      loadFailed: '剧集加载失败',
      createFailed: '创建失败',
      updateFailed: '保存失败',
      duplicateFailed: '复制失败',
      deleteFailed: '删除失败',
      created: '剧集已创建',
      updated: '剧集已保存',
      duplicated: '剧集已复制',
      archived: '剧集已归档',
      deleted: '剧集已删除',
      confirmDelete: '确认处理该剧集？已发布或有用户数据时会归档，未发布且无关联数据时会永久删除。',
      confirmTextLabel: '输入 {title} 确认继续',
      scenes: '场景',
      endings: '结局',
      updatedAt: '更新',
    },
    status: {
      draft: 'DRAFT',
      published: 'PUBLISHED',
      archived: 'ARCHIVED',
      unknown: 'UNKNOWN',
    },
    enumOptions: enumOptionsZh,
    sectionGroups: {
      basic: '基础',
      state: '数值与状态',
      world: '世界',
      cast: '角色与物件',
      info: '信息',
      gameplay: '玩法',
      ending: '结局',
      assets: '资产',
    },
    editor: {
      title: '剧本编辑',
      subtitle: '按 section 维护地图、角色、任务、规则、结局与素材。',
      section: '当前段',
      readonly: '你没有此剧集的编辑权限',
      unsaved: '未保存改动',
      saved: '已保存',
      save: '保存',
      revert: '撤销',
      savedToast: '当前段已保存',
      saveFailed: '保存失败',
      discardConfirm: '当前段有未保存改动，确认放弃吗？',
      discardTitle: '放弃未保存改动',
      discardBody: '当前 section 还有未保存改动。离开后这些改动不会写入数据库。',
      stayEditing: '继续编辑',
      discardCta: '放弃改动',
      deleteEntityTitle: '删除条目',
      deleteEntityBody: '该条目将从当前 section 移除，保存后写入数据库。',
      deleteEntityBlocked: '该条目被 {count} 处引用。请先移除引用后再删除。',
      deleteEntityConfirmLabel: '输入 {label} 确认删除',
      deleteEntityCta: '确认删除',
      recentChanges: '最近变更',
      recentChangesHint: '展示当前剧本草稿的写库审计记录。',
      auditLoading: '加载变更记录中',
      auditLoadFailed: '变更记录加载失败',
      noRecentChanges: '暂无变更记录',
      auditActions: {
        section_update: '保存 section',
        asset_upload: '上传素材',
        asset_delete: '删除素材',
        compile: '编译',
        publish: '发布',
        rollback: '回滚',
      },
      focusedCheck: '当前发布校验定位',
      structuredTab: '结构化',
      jsonTab: 'JSON',
      jsonHelp: 'JSON 内容解析通过后会同步回结构化表单。',
      jsonInvalid: 'JSON 无效',
      addRow: '新增',
      searchOptions: '搜索选项',
      dragRow: '拖拽排序',
      duplicateRow: '复制',
      removeRow: '移除',
      emptyRows: '暂无条目',
      item: '条目',
      noId: '未设置 ID',
      sections: {
        mapLocations: '地点',
        mapGraph: '地点连接图',
        npcs: 'NPC',
        objects: '物件',
        clues: '线索',
        conclusions: '结论',
        infoBlocks: '信息块',
        sceneEvents: '场景事件',
        actionRules: '行动规则',
        endings: '结局',
        stateRegistry: '状态字典',
        players: '玩家角色',
        quests: '任务',
        mediaTags: '素材标签',
        videoReferences: '视频生成设定图',
        stageRules: '阶段规则',
        audioRules: '音频规则',
        voiceSettings: '音色配置',
        voiceSettingsHelp: '先设置 default 音色；各语言列可覆盖运行时音色，留空则继承 default。',
        audioMoodRules: 'BGM 规则',
        statSfxRules: '数值音效',
        stateCgRules: '状态 CG 规则',
        followupRules: '后续过场',
      },
      stateWorkspace: {
        initialTitle: '开局实际值',
        initialBody: '新游戏创建 run 时会把这里的值写进去，例如全局 flag、NPC 当前状态、任务进度、物件状态和初始背包。',
        registryTitle: '状态字典',
        registryBody: '这是状态 key 的说明书。它说明每个 key 表示什么、谁会写入、谁会读取，以及会影响哪段剧情或规则。',
        relationshipTitle: '两者关系',
        relationshipBody: '开局值决定“开始时是什么”，状态字典说明“这个 key 是什么”。字典不会替代开局值；用于发布检查、规则引用和后续维护。',
        openingValues: '开局值',
        registeredKeys: '已登记 key',
        initialHint: '只放开局必须存在的值。NPC、物件这类嵌套对象会展开成点路径，方便和字典 key 对齐。',
        registryHint: '每个被行动规则、条件、KP 或 Agent 读取的状态 key 都建议登记。写清来源和影响，后面排查剧情状态会容易很多。',
        registryTableTitle: '状态字典条目',
        unregisteredInitialKeys: '这些开局 key 还没有字典说明：',
        keyPurpose: '用途',
        noRegistryNote: '未登记用途',
        noRegistryHint: '在下方状态字典添加同名 key 后，这里会显示它的含义和运行时影响。',
      },
      sceneWorkspace: {
        scenesGroup: '场景',
        emptyScenes: '还没有场景，请先在“地图”里添加地点。',
        noScene: '请先在地图里创建场景。',
        noDescription: '这个场景还没有描述。',
        unlocked: '开局可进入',
        locked: '需解锁',
        sceneObjects: '本场景物件定义',
        sceneClues: '本场景线索',
        sceneInfoBlocks: '本场景信息块',
        sceneEvents: '本场景事件',
        sceneActionRules: '本场景规则',
        npcNote: '这里选择本场景出现的全局 NPC，并维护它们在本场景的开局状态。完整人设仍在 NPC 全局定义。',
        objectNote: '这里维护场景挂载的全局物件；物件定义会写回全局 objects，场景归属写回 map.locations[].objectIds。',
        clueNote: '这里按当前场景过滤全局线索。新增线索会自动写入当前场景归属。',
        infoNote: '这里按本场景 NPC 过滤信息块。只有属于本场景 NPC 的信息会显示。',
        eventNote: '这里按当前场景过滤事件。保存时事件 locationId 会写成当前场景。',
        ruleNote: '这里按当前场景过滤行动规则。新增规则会自动补当前 location 条件，避免误变成全局规则。',
        tabs: {
          overview: '总览',
          basic: '基础',
          connections: '连接',
          npcs: 'NPC',
          objects: '物件',
          clues: '线索',
          infoBlocks: '信息块',
          sceneEvents: '事件',
          actionRules: '规则',
        },
        hints: {
          basic: '场景名称、描述、类型和素材。',
          connections: '从当前场景通往其它场景的移动关系。',
          npcs: '本场景出现哪些 NPC，以及它们的开局状态。',
          objects: '本场景挂载哪些全局物件，并可编辑这些物件定义。',
          clues: '和当前场景、场景 NPC 或场景物件相关的线索。',
          infoBlocks: '属于本场景 NPC 的可说信息和隐藏事实。',
          sceneEvents: '归属当前场景的进入、发现或自定义事件。',
          actionRules: '只和当前场景目标或 location 条件相关的规则。',
        },
      },
      mediaUsage: {
        title: '素材使用关系',
        subtitle: '这里展示当前剧本素材在游戏流程中的真实绑定位置；修改对应关系后，保存会写入结构化数据表，game 端按同一关系播放。',
        missingAsset: '素材清单中没有这个 tag',
        opening: '首页开场 CG',
        endingBook: '结局书册背景',
        entryStage: '入场主画面',
        entryStageIdle: '入场待机视频',
        defaultStage: '默认场景画面',
        defaultStageIdle: '默认待机视频',
        revealedStage: '揭示后主画面',
        revealedStageIdle: '揭示后待机视频',
        defaultBgm: '默认 BGM',
        editInMedia: '在“素材”菜单的全局规则中编辑',
        editInMediaStageRules: '在“素材”菜单的阶段规则中编辑',
        editInMediaAudioRules: '在“素材”菜单的音频规则中编辑',
        editInMediaStateCgs: '在“素材”菜单的状态 CG 规则中编辑',
        editInMediaFollowups: '在“素材”菜单的后续过场中编辑',
        editInMap: '在“地图”菜单的地点素材中编辑',
        editInNpcs: '在“NPC”菜单的媒体 tag 中编辑',
        editInPlayers: '在“玩家角色”菜单的头像素材中编辑',
        editInEndings: '在“结局”菜单的结局 CG 中编辑',
      },
      sectionCatalog: sectionCatalogZh,
      fieldGroups: {
        public: '公开层',
        secret: '秘密层',
        secretBadge: '秘密·玩家不可见',
      },
      fields: {
        id: 'ID',
        name: '名称',
        type: '类型',
        state: '状态',
        label: '标签',
        scope: '作用域',
        source: '来源',
        detail: '详情',
        summary: '摘要',
        prerequisiteConclusions: '前置结论',
        relatedClues: '相关线索',
        content: '内容',
        priority: '优先级',
        target: '目标',
        targetType: '目标类型',
        mode: '模式',
        intent: '意图',
        claim: '声明',
        claims: '语义声明',
        mediaTag: '媒体 tag',
        referenceAssets: '参考素材',
        stageMediaTags: '阶段立绘',
        phaseKey: '阶段',
        tag: 'Tag',
        file: '文件',
        objectKey: '对象 key',
        mime: 'MIME',
        width: '宽',
        height: '高',
        packId: '剧本 ID',
        title: '标题',
        tagline: '一句话简介',
        assetManifestId: '素材清单 ID',
        videoSceneReferenceTag: '场景设定图',
        videoNpcReferenceTag: 'NPC 设定图',
        videoPlayerReferenceTag: '玩家设定图',
        coverTag: '横屏封面（无竖屏封面时展示）',
        portrait_cover_tag: '竖屏封面（9:16）',
        opening: '开场文本',
        seoTitle: '列表标题',
        seoDescription: '列表摘要',
        initialLocation: '初始地点',
        none: '未选择',
        initialPhase: '初始阶段',
        turnLimit: '回合上限',
        openingStrategy: '开局策略',
        defaultActionMode: '默认行动模式',
        statsDefinitions: '数值定义',
        statId: 'ID',
        statName: '名称',
        statColor: '颜色',
        initialValue: '初值',
        description: '描述',
        statRules: '数值调整规则',
        initialStates: '初始状态',
        stateKey: '状态键',
        stateValue: '状态值',
        initialFlags: '初始 flags',
        initialNpcStates: '初始 NPC 状态',
        initialQuestStates: '初始任务状态',
        initialSceneEventStates: '初始事件状态',
        initialObjectStates: '初始物件状态',
        initialInventory: '初始背包',
        primaryNpcId: '主 NPC',
        keeperRole: 'KP 角色设定',
        dynamicStoryEnabled: '开启动态剧情',
        singleScene: '单场景模式',
        minDistinctTurns: '最少有效推进回合',
        maxActiveBranches: '同时活跃分支上限',
        maxGeneratedEndings: '单局生成结局上限',
        trackerExpiry: '剧情方向失效回合数',
        dynamicStoryPrinciples: '动态剧情生成原则',
        dynamicStoryForbidden: '动态剧情生成禁区',
        referenceEndings: '参考结局',
        referenceEndingsHint: '只供分支生成器理解本剧本允许的结果结构，不会进入普通 KP 或 NPC 提示词。',
        referenceEnding: '参考结局',
        requiredConsequences: '必须产生的结果',
        phaseRules: '阶段规则',
        phase: '阶段',
        principles: '导戏原则',
        forbidden: '禁忌规则',
        hiddenFacts: '隐藏事实',
        displayName: '展示名',
        publicProfile: '公开人设',
        trueProfile: '真实人设',
        coverRole: '伪装身份',
        coverStory: '伪装故事',
        coverAttitude: '伪装态度',
        species: '真实物种',
        origin: '来源',
        hunger: '欲望',
        limitation: '限制',
        danger: '危险',
        appearance: '外观',
        publicKnowledge: '公开知识',
        privateKnowledge: '私密知识',
        disclosePolicy: '披露策略',
        boundaries: '边界',
        mustDo: '必须做',
        mustNotDo: '禁止做',
        usable: '可用',
        damaged: '损坏',
        known: '已知',
        importance: '重要性',
        ownerNpc: '所属 NPC',
        startsUnlocked: '初始解锁',
        unlockWhen: '解锁条件',
        speakableAs: '可说出口的话',
        locationId: '地点 ID',
        once: '只触发一次',
        triggerWhen: '触发条件',
        whenCondition: '匹配条件',
        requires: '前置条件',
        invalidReason: '无效原因',
        overrideKp: '覆盖 KP',
        stopProcessing: '停止后续规则',
        targetsAll: '全部目标',
        effectsStats: '数值变化',
        effectsFlags: '设置 flags',
        effectsEvidence: '新增证据',
        locationChange: '移动到地点',
        unlockLocations: '解锁地点',
        lockLocations: '锁定地点',
        addInventory: '新增物品',
        removeInventory: '移除物品',
        sceneNarration: '场景叙述',
        visibleFindings: '可见发现',
        discoveredObjects: '发现物件',
        npcReaction: 'NPC 反应策略',
        npcDirectiveNpc: '指定 NPC',
        npcDirectiveTactic: 'NPC 策略',
        npcDirectiveMood: 'NPC 情绪',
        mustReactTo: '必须回应',
        mustHide: '必须隐瞒',
        possibleEnding: '立即结局',
        reason: '原因说明',
        valueType: '值类型',
        hardState: '硬状态',
        writers: '写入者',
        readers: '读取者',
        runtimeEffect: '运行时影响',
        notes: '备注',
        npcIds: 'NPC IDs',
        objectIds: '物件 IDs',
        sceneEventIds: '事件 IDs',
        connections: '连接',
        to: '去往',
        locked: '锁定',
        lockedReason: '锁定原因',
        defaultCharacterId: '默认角色',
        showInSelection: '在角色选择中显示',
        gender: '性别',
        age: '年龄',
        archetype: '原型',
        portraitTag: '头像素材',
        attributes: '属性',
        skills: '技能',
        inventory: '背包',
        history: '经历',
        traits: '特质',
        mainQuestId: '主任务',
        statusAtStart: '初始状态',
        steps: '步骤',
        completeWhen: '完成条件',
        failWhen: '失败条件',
        entryTag: '入场 tag',
        entryIdleTag: '入场待机 tag',
        defaultTag: '默认 tag',
        defaultIdleTag: '默认待机 tag',
        revealedTag: '揭示 tag',
        revealedIdleTag: '揭示待机 tag',
        openingTag: '开场 CG tag',
        endingBookTag: '结局书册 tag',
        idleTag: '待机视频 tag',
        mood: '氛围',
        statKey: '数值键',
        triggerType: '触发类型',
        statePath: '状态路径',
        threshold: '阈值',
        oncePerRun: '每局只播一次',
        triggerScope: '触发范围',
        sortOrder: '排序',
        defaultBgmTag: '默认 BGM tag',
        defaultBgmMood: '默认 BGM 氛围',
        voiceRole: '角色',
        defaultVoice: 'Default 音色',
        inheritDefaultVoice: '继承 default',
        playerVoiceId: '玩家音色',
        npcVoiceId: 'NPC 音色',
        endingVoiceId: '结局音色',
      },
    },
    conditions: conditionMessages.zh,
    assets: {
      title: '素材',
      subtitle: '管理立绘、CG、音频与引用占用。',
      file: '文件',
      search: '搜索 tag、MIME 或 object key',
      upload: '上传素材',
      uploading: '上传中',
      uploaded: '素材已上传',
      uploadFailed: '素材上传失败',
      generateImage: 'AI 生成图片',
      generatingImage: '图片生成中',
      imageGenerated: '图片已生成并登记为素材',
      imageGenerationFailed: '图片生成失败',
      image_purpose: '图片用途',
      image_purpose_asset: '普通素材',
      image_purpose_portrait_cover: '竖屏封面',
      portrait_cover_hint: '生成 9:16 竖屏封面（1080 × 1920）。生成后，请在剧本信息中将它选为竖屏封面。',
      imagePrompt: '图片描述',
      imagePromptHint: '将调用 Seedream 生成一张 2K 图片，并自动保存到当前剧本素材。',
      deleted: '素材已删除',
      delete: '删除素材',
      deleteFailed: '素材删除失败',
      openFile: '打开文件',
      inspect: '查看',
      inspector: '素材检视',
      selectAsset: '选择一个素材查看预览、元数据和引用占用。',
      noPreview: '没有可预览文件',
      noMetadata: '暂无元数据',
      loading: '加载素材中',
      loadFailed: '素材加载失败',
      emptyTitle: '上传第一个立绘或 CG',
      empty: '暂无素材',
      duplicateTag: '该 tag 已存在，请改用唯一 tag。',
      referenceCount: '{count} 处引用',
      references: '引用占用',
      noReferences: '当前没有被 section 引用。',
      confirmDeleteTitle: '删除素材',
      confirmDeleteBody: '该素材将从当前草稿移除。',
      confirmReferencedDeleteBody: '该素材被 {count} 处引用。删除后这些引用会失效，请先确认。',
      confirmTextLabel: '输入 {tag} 确认删除',
      confirmDeleteCta: '确认删除',
      coverage: {
        total: '素材总量',
        referenced: '已接入剧情',
        unreferenced: '未接入',
        unreferencedTags: '未接入素材 tag',
        none: '所有素材都已经被剧情字段引用。',
      },
      filters: { all: '全部' },
      groups: { cg: 'CG 与过场', character: '角色与立绘', scene: '场景与参考', audio: '音乐与音效', ui: '界面素材', reference: '参考图', other: '其他文件' },
      types: { image: '图片', video: '视频', audio: '音频', asset: '文件' },
      meta: {
        type: '类型',
        mime: 'MIME',
        dimensions: '尺寸',
        objectKey: 'Object key',
        hash: 'Hash',
      },
    },
    versions: {
      title: '版本',
      subtitle: '编译、校验、发布、回滚与玩家端预览。',
      compile: '编译草稿',
      compiling: '编译中',
      compileDone: '编译完成',
      compileFailed: '编译失败',
      loadChecksFailed: '发布校验加载失败',
      publishDone: '版本已发布',
      publishFailed: '发布失败',
      previewFailed: '预览授权失败',
      rollback: '回滚',
      rollbackDone: '已回滚',
      rollbackFailed: '回滚失败',
      checks: '发布校验',
      noChecks: '当前版本暂无校验项；请先编译草稿或选择一个版本。',
      version: '版本',
      emptyTitle: '还没有版本',
      empty: '暂无版本，先编译草稿。',
      publishBlocked: '存在阻断发布的校验项，修复后才能发布。',
      jumpToSection: '打开对应 section',
      snapshot: '编译快照',
      openSnapshot: '查看快照',
      closeSnapshot: '收起快照',
      noSnapshot: '该版本暂无可查看的编译快照。',
      checkStatus: {
        ok: '通过',
        warning: '警告',
        error: '错误',
        empty: '无校验',
      },
      checkSummary: {
        ok: '所有校验已通过。',
        warning: '还有 {warnings} 条警告需要确认。',
        error: '还有 {errors} 条阻断项必须修复。',
        empty: '尚未加载校验结果。',
      },
      confirm: {
        publishTitle: '发布版本',
        publishBody: '发布后玩家端会使用该版本作为当前线上版本。',
        publishCta: '确认发布',
        rollbackTitle: '回滚版本',
        rollbackBody: '回滚会把当前线上版本切换到所选版本，正在游玩的用户数据不会被删除。',
        rollbackAcknowledge: '我了解回滚会切换线上版本，并确认继续操作。',
        rollbackCta: '确认回滚',
      },
    },
    localization: {
      title: '游戏内容多语言',
      description: '选择版本后，按语言手动生成或更新译文。新版本需要重新处理，不会在保存草稿时自动翻译。',
      externalNotice: '点击生成后，该版本的剧情文本会发送给平台配置的翻译模型，并将结果保存到内容翻译表。',
      sourceSummary: '该版本包含 {count} 条待本地化文本。',
      loading: '正在读取翻译状态…',
      loadFailed: '翻译状态加载失败',
      generate: '生成翻译',
      generateAll: '一键生成全部语言（{count}）',
      generatingAll: '正在生成全部语言…',
      batchProgress: '正在处理第 {current} / {total} 个语言 · 已完成 {completed} 个',
      generateAllDone: '已完成 {count} 个语言的翻译',
      generateAllFailed: '批量翻译完成：成功 {completed} 个，失败 {failed} 个',
      allAlreadyDone: '所有语言均已完成，无需重复生成',
      regenerate: '重新生成',
      generating: '生成中…',
      generateDone: '翻译已生成',
      generateFailed: '翻译生成失败',
      progressLoadFailed: '翻译仍在继续，但进度暂时无法读取',
      progressStatus: { idle: '正在准备', translating: '正在翻译', saving: '正在保存', completed: '已完成', failed: '生成失败' },
      status: { source: '源语言', missing: '待处理', ready: '已完成' },
      locales: { 'zh-CN': '简体中文', en: '英语', ja: '日语', ko: '韩语', es: '西班牙语', pt: '葡萄牙语' },
    },
    translationInventory: {
      title: '内容明细', all: '全部', pending: '待翻译', reused: '复用旧译文', translated: '已翻译',
      source: '原文', target: '目标语言译文', notTranslated: '尚未翻译', empty: '当前筛选条件下没有内容。',
      reuseFrom: '未修改内容将从 {version} 复用。', reusableCount: '可复用 {count} 条', pendingCount: '待翻译 {count} 条',
    },
    common: {
      retry: '重试',
      refresh: '刷新',
      open: '打开',
      close: '关闭',
      more: '更多',
      required: '必填',
    },
  },
}
